export const namespace = 'POPOVER';
const ns = (name) => `${namespace}/${name}`;

export const SHOW_POPOVER = ns('SHOW_POPOVER');
export const HIDE_POPOVER = ns('HIDE_POPOVER');
